<div class="dialog-header flex justify-content-between align-items-center w-full">
  <h2>Confirmare</h2>
  <p-button
    size="small"
    mat-dialog-close
    icon="pi pi-times"
    severity="secondary"
    [rounded]="true"
    [text]="true"
  />
</div>
<mat-dialog-content>
  <p class="font-bold">Sunteți sigur că doriți să resetați parola pentru acest utilizator?</p>
  <div class="flex flex-column">
    <p class="m-0"><b>Nume</b>: {{ user.name }}</p>
    <p class="m-0"><b>Email</b>: {{ user.email }}</p>
    <p class="m-0"><b>Telefon</b>: {{ user.phone }}</p>
    <p class="m-0"><b>Rol</b>: {{ user.role }}</p>
  </div>
  <p-messages
    styleClass="text-xs"
    [value]="warnMessage()"
    [enableService]="false"
    [closable]="false"
  ></p-messages>
  <div class="flex align-items-center gap-2 mt-4 mb-2">
    <p-checkbox
      inputId="confirm-delete"
      [binary]="true"
      (onChange)="confirmed.set($event.checked)"
    ></p-checkbox>
    <label for="confirm-delete">Confirm resetarea parolei</label>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="flex gap-2">
  <p-button
    size="small"
    mat-dialog-close
    data-testid="dialog-secondary"
    label="Anulează"
    [text]="true"
  ></p-button>
  <p-button
    size="small"
    data-testid="dialog-primary"
    label="Resetează"
    icon="pi pi-refresh"
    [disabled]="!confirmed()"
    (onClick)="resetPassword()"
  ></p-button>
</mat-dialog-actions>
@if (reseting()) {
  <div class="blurred-div">
    <p-progressSpinner class="blurred-div-spinner"></p-progressSpinner>
  </div>
}